import { VirtualAvvenimentoSportLike } from 'lib/api/virtual/virtualProssimePartenzeResponseApi';

/* eslint-disable no-unused-vars */
export enum ScommessaCorsaTipo {
  Aperta = 'Aperta',
  Chiusa = 'Chiusa',
  Campi = 'Campi',
  Check = 'Check',
}

export enum ProssimePartenzeEnum {
  SPORT = 'prossimePartenzeSport',
  CORSA = 'prossimePartenzeCorsa',
  GENERALI = 'prossimePartenzeGenerali',
}
export type ProssimePartenzeType = `${ProssimePartenzeEnum}`;
/* eslint-enable no-unused-vars */

export type Corridore = {
  id: string;
  posPartenza: string;
  posFinale: string;
  codiceTipoScommessa: number;
  keyAvvenimento: string;
};

// Definisci un tipo per gli oggetti
export type CheckboxState = {
  checked: boolean;
  disabled: boolean;
};

export type VirtualListVideoStreamingType = {
  [key: string]: Array<string>;
};

export enum CombinationType {
  ACCOPPIATA_IN_ORDINE = '2-ordine',
  TRIO_IN_ORDINE = '3-ordine',
  ACCOPPIATA_IN_DISORDINE = '2-disordine',
  TRIO_IN_DISORDINE = '3-disordine',
}

export enum VirtualGiornataType {
  INDEX_GIORNATA = 'indexGiornata',
  INDEX_GIORNATA_TIPO_SCOMMESSA = 'indexGiornataTipoScommessa',
}

export enum VirtualTemplateType {
  TEMPLATE_CORSA = '0',
  TEMPLATE_SPORT = '1',
}

export enum VirtualTemplateAvvenimentoType {
  TEMPLATE_CORSA_AVVENIMENTO = 'templateCorseAvvenimento',
  TEMPLATE_SPORT_AVVENIMENTO = 'templateSportAvvenimento',
}

export type VirtualProssimePartenzeListType = VirtualAvvenimentoSportLike;
